import { Title } from "@mecha/design-components/dist/src/components/Elements/Typography/Title";
import SettingsNavigation from "../Settings/SettingsNavigation";

type Props = {
  children?: any;
  title?: string;
};

const SettingsLayout = ({ children, title }: Props) => {
  return (
    <div className="flex w-full items-start dark:bg-dark bg-storm-dust-110 lg:justify-center pb-10">
      <div className="w-full 2xl:container 2xl:mx-auto 2xl:px-0 xs:px-4 lg:px-8 min-h-[calc(100vh-64px)]">
        {/* <Title
          color="neutral"
          className="py-5 md:border-b md:dark:border-custom-800 md:border-custom-500 lg:mb-5 text-[32px] font-space-grotesk"
        >
          Settings
        </Title> */}
        <div className="mt-5 md:mt-10 w-full flex xs:flex-wrap xs:space-y-5 lg:space-y-0 lg:flex-nowrap lg:flex-row">
          <div className="xs:w-full lg:w-1/6 xs:overflow-x-auto xs:overflow-hidden lg:overflow-hidden no-scrollbar xs:border-b lg:border-b-0 xs:-mb-1.5 dark:border-neutral-150 mr-5">
            <SettingsNavigation title={title} />
          </div>
          <div className="xs:w-full lg:w-auto lg:flex-1 flex lg:px-4  flex-col">
            <p className="text-2xl font-medium dark:text-dark-n-400 text-light-n-400 mb-6 mt-3">
              {title}
            </p>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsLayout;
